/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectModel } from './ProjectModel';
import {
    ProjectModelFromJSON,
    ProjectModelFromJSONTyped,
    ProjectModelToJSON,
} from './ProjectModel';

/**
 *
 * @export
 * @interface ListProjectResponse
 */
export interface ListProjectResponse {
    /**
     *
     * @type {number}
     * @memberof ListProjectResponse
     */
    limit: number;
    /**
     *
     * @type {number}
     * @memberof ListProjectResponse
     */
    offset: number;
    /**
     *
     * @type {number}
     * @memberof ListProjectResponse
     */
    total: number;
    /**
     *
     * @type {Array<ProjectModel>}
     * @memberof ListProjectResponse
     */
    projects: Array<ProjectModel>;
}

/**
 * Check if a given object implements the ListProjectResponse interface.
 */
export function instanceOfListProjectResponse(value: object): boolean {
    if (!('limit' in value)) return false;
    if (!('offset' in value)) return false;
    if (!('total' in value)) return false;
    if (!('projects' in value)) return false;
    return true;
}

export function ListProjectResponseFromJSON(json: any): ListProjectResponse {
    return ListProjectResponseFromJSONTyped(json, false);
}

export function ListProjectResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ListProjectResponse {
    if (json == null) {
        return json;
    }
    return {
        limit: json['limit'],
        offset: json['offset'],
        total: json['total'],
        projects: (json['projects'] as Array<any>).map(ProjectModelFromJSON),
    };
}

export function ListProjectResponseToJSON(value?: ListProjectResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        limit: value['limit'],
        offset: value['offset'],
        total: value['total'],
        projects: (value['projects'] as Array<any>).map(ProjectModelToJSON),
    };
}
